module.exports = __webpack_public_path__ + "static/media/stage.1c950cd6.png";